import { z } from 'zod';

import { fixture } from './fixtures';

export const TeamRequestChangeSchema = z.object({
	id: z.string(),
	changeType: z.enum(['add_report', 'remove_report', 'change_manager']),
	state: z.enum(['pending_confirmation', 'pending_admin', 'approved', 'declined']),
	targetUserId: z.string().nullable(),
	currentManagerId: z.string().nullable(),
	newManagerId: z.string().nullable(),
	confirmedById: z.string().nullable(),
	confirmedAt: z.string().nullable(),
	decidedById: z.string().nullable(),
	decidedAt: z.string().nullable(),
	targetUser: z
		.object({
			id: z.string(),
			displayName: z.string(),
			profilePicUrl: z.string().optional(),
			username: z.string().optional(),
		})
		.nullable()
		.optional(),
	currentManager: z
		.object({
			id: z.string(),
			displayName: z.string(),
			profilePicUrl: z.string().optional(),
		})
		.nullable()
		.optional(),
	newManager: z
		.object({
			id: z.string(),
			displayName: z.string(),
			profilePicUrl: z.string().optional(),
		})
		.nullable()
		.optional(),
});

export type TeamRequestChange = z.infer<typeof TeamRequestChangeSchema>;

export const TeamRequestSchema = z.object({
	id: z.string(),
	companyId: z.string(),
	requesterId: z.string(),
	state: z.enum(['pending', 'approved', 'declined', 'cancelled']),
	submittedAt: z.string(),
	decidedAt: z.string().nullable(),
	decidedById: z.string().nullable(),
	adminNotes: z.string().nullable(),
	requester: z
		.object({
			id: z.string(),
			displayName: z.string(),
			profilePicUrl: z.string().optional(),
			username: z.string().optional(),
		})
		.nullable()
		.optional(),
	decidedBy: z
		.object({
			id: z.string(),
			displayName: z.string(),
		})
		.nullable()
		.optional(),
	changes: z.array(TeamRequestChangeSchema),
});

export type TeamRequest = z.infer<typeof TeamRequestSchema>;

export const TeamRequestListSchema = z.object({
	records: z.array(TeamRequestSchema),
	totalCount: z.number().optional(),
	page: z.number().optional(),
	perPage: z.number().optional(),
});

export type TeamRequestList = z.infer<typeof TeamRequestListSchema>;

export const teamRequestFixture = (overrides: Partial<TeamRequest> = {}): TeamRequest => ({
	id: fixture.id(),
	companyId: fixture.id(),
	requesterId: fixture.id(),
	state: 'pending',
	submittedAt: new Date().toISOString(),
	decidedAt: null,
	decidedById: null,
	adminNotes: null,
	requester: null,
	decidedBy: null,
	changes: [],
	...overrides,
});
